import clsx from "clsx";
import './styles/nav-button.scss'

const NavButton = ({ text, icon, href, isSelected, className, onClick }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <a className={clsx('nav-button-root button-with-rotate-svg', className)} href={href} onClick={handleClick}>
            <div className={clsx('flex gap-2 items-center text-white', {
                'selected': isSelected,
            })}>
                {icon}
                <span className='open-sans-semibold'>{text}</span>
            </div>
        </a>
    )
}

export default NavButton;
